module.exports = __webpack_public_path__ + "resources/img/img_rancher3_m.a53aeaa9452f642db8c72afb2b39bfc5.png";